import { render, staticRenderFns } from "./CsvExampleModal.vue?vue&type=template&id=2b3585a5&scoped=true"
import script from "./CsvExampleModal.vue?vue&type=script&lang=js"
export * from "./CsvExampleModal.vue?vue&type=script&lang=js"
import style0 from "./CsvExampleModal.vue?vue&type=style&index=0&id=2b3585a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3585a5",
  null
  
)

export default component.exports